function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 99.6 99.6"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M49.8 1.52A48.28 48.28 0 1 0 98.08 49.8 48.27 48.27 0 0 0 49.8 1.52Zm-6.47 74.1a3.59 3.59 0 0 1-5.09 0L14.81 52.19a3.59 3.59 0 0 1 0-5.09l5.1-5.1A3.61 3.61 0 0 1 25 42l15.79 15.78L74.6 24a3.57 3.57 0 0 1 5.09 0l5.1 5.09a3.6 3.6 0 0 1 0 5.1Z",
  style: {
    strokeMiterlimit: 10,
    strokeWidth: "3.05px"
  },
  "data-name": "Layer 2"
}));
export default SvgChecked;